module.exports = __webpack_public_path__ + "static/steampunk-b629ba670ac388fcda510041098e54db.png";